import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.min.css';
import { getFilmAwardsPageData, updateFilmAwardsPageData, deleteFilmAwardsPageData } from '../../../services/Films';
import { Box, Flex, useToast } from '@chakra-ui/react';
import { getRemovedValues } from '../../../util/helper';
import SubmitButton from '../../../CommonComponents/SubmitButton';
import { DataNotFound } from '../../../CommonComponents/DataNotFound';
import FormLoader from '../../../CommonComponents/FormLoader';
import { showErrorToast, showSuccessToast } from '../../../util/errorHandler';



const Awards = () => {

  const { alias } = useParams();
  const [awardPageData, setAwardsPageData] = useState();
  const [columnHeaders, setColumnHeaders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const hotRef = useRef(null);
  const toast = useToast();

  // const handleAutoSave = async (changes, source) => {
  //   if (source === "edit") {
  //     // Iterate over the changes array
  //     for (const [row, col, oldValue, newValue] of changes) {
  //       // Retrieve the column header using the column index (col)
  //       const editedField = columnHeaders[col]; // Assuming columnHeaders is an array of header names
  
  //       // If the value has changed (old value is different from new value)
  //       if (oldValue !== newValue) {
  //         const updateValue = newValue;
  
  //         // Prepare the data to be sent in the API request
  //         const data = {
  //           "_id": tableData?.[row]?.[0], // Assuming first column (_id) is at index 0
  //           [editedField]: updateValue,    // Dynamically set the field name (e.g., "landing_page_title")
  //         };
  
  //         // Make the API call to update the data
  //         try {
  //           const result = await updateFilmAwardsPageData(alias, data);
  //           console.log("Save result:", result);
  //         } catch (error) {
  //           console.error("Error saving data:", error);
  //         }
  //       }
  //     }
  //   }
  // };

  useEffect(() => {
    const getLandingPageData = async () => {
      try {
        if (alias) {
          const result = await getFilmAwardsPageData(alias);
          if (result && result.data?.length > 0) {
            setAwardsPageData(result);

            const keys = Object.keys(result.data[0]);
            setColumnHeaders(keys);
            const rowData = result.data.map((item) =>
                keys.map((key) => item[key] ?? "") // Extract values by key
              );
              setTableData(rowData);

          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
                showErrorToast(toast, "Failed to fetch film data");
      } finally {
        setIsLoading(false);
      }
    };

    getLandingPageData();
  }, [alias, toast]);

  const saveClickCallback = async () => {
    const hot = hotRef.current.hotInstance;
    const data = hot.getData();
    const headers = hot.getColHeader();

    const formattedData = data
        .filter(row => row.some(cell => cell !== null && cell !== ''))
        .map(row => {
        const rowData = {};
        headers.forEach((header, index) => {
            if (row[index] !== null && row[index] !== '') {
            rowData[header] = row[index];
            }
        });

        return rowData;
        });

    if (formattedData?.length > 0) {
      setIsSubmitting(true);
        try {
        // Use the same function for both new and existing records
            const result = await updateFilmAwardsPageData(alias, formattedData);

            if (result?.status === 200)
            {
                                showSuccessToast(toast, "Data saved successfully");
            }

        } catch (error) {
                console.error("Error saving row:", error);
        }
        finally
        {
          setIsSubmitting(false);
        }
    }

    const deletedItems = getRemovedValues(awardPageData?.data,formattedData);

    if (deletedItems?.length > 0) {
        try {
            // Use the same function for both new and existing records
            const result = await deleteFilmAwardsPageData(alias, deletedItems);

            if (result?.status === 200)
            {
                                showSuccessToast(toast, "Data saved successfully");
            }
        } catch (error) 
        {
            console.error("Error saving row:", error);
        }
    }
 };

  const hotTableSettings = {
    data: tableData,
    colHeaders: columnHeaders,
    rowHeaders: true,
    height: "auto",
    // afterChange: handleAutoSave,
    licenseKey: "non-commercial-and-evaluation",
    autoWrapRow: true,
    contextMenu: true,
    cells: (row, col) => (col === 0 ? { readOnly: true } : {}), // Make the first column read-only
    hiddenColumns: {
      columns: [columnHeaders.indexOf('_id'),columnHeaders.indexOf('wnn'), columnHeaders.indexOf('__v')], // Hide id, wnn, __v
      indicators: false, // No visual indicators for hidden columns
    },
    beforeCopy: (data, coords) => {
      const hot = hotRef.current?.hotInstance; // Get the Handsontable instance from the ref
      if (!hot) return;
  
      coords.forEach(coord => {
        for (let row = coord.startRow; row <= coord.endRow; row++) {
          for (let col = coord.startCol; col <= coord.endCol; col++) {
            // Skip hidden columns
            if (hot.getPlugin('hiddenColumns').isHidden(col)) {
              data[row - coord.startRow][col - coord.startCol] = ''; // Clear hidden column data
            }
          }
        }
      });
    },
    plugins: ["hiddenColumns"],
  };

  return (
    <Box >
      {isLoading ? (
        <FormLoader />
      ) : (
        <>
        { awardPageData?.data?.length > 0 ? (
          <>
          <Flex justifyContent="flex-start" mb={4}>
          <SubmitButton isLoading={isSubmitting} onClick={saveClickCallback}/>
          </Flex>
          {/* Handsontable */}
          <HotTable
          ref={hotRef}
          {...hotTableSettings}
            />
          {/* Optional Second Save Button (aligned right) */}
          <Flex justifyContent="flex-start" mt={4}>
          <SubmitButton isLoading={isSubmitting} onClick={saveClickCallback}/>
          </Flex>
          </>
        ) : (
          <DataNotFound />
        )}
        </>
      )}
    </Box>
  );
};

export default Awards;
